import { convertToHebrew } from "jewish-dates-core";

const heYear = (year) => {
  year = convertToHebrew(year, true, true);
  return year.slice(1, year.length);
};

export default heYear;
